// extracted by mini-css-extract-plugin
export default {"cardContainer":"BlurredCard_cardContainer__rOsvE","cardContent":"BlurredCard_cardContent__PeITs"};